import SituacionLaboralList from './SituacionLaboralList'
export {SituacionLaboralList}
export default SituacionLaboralList
